



































import { Vue, Component, Prop } from "vue-property-decorator";
import { IImport } from "@/models/imports";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";

@Component({
  components: {
    "import-provider": () =>
      import("@/components/app/admin/imports/importProvider.vue"),
    "import-messages": () =>
      import("@/components/app/admin/imports/importMessages.vue")
  }
})
export default class AdminImportView extends Vue {
  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;
  // Data
  public importId: IImport["id"] = this.$route.params.importId;

  // Computed

  public get breadcrumbs(): ICrumb[] {
    return [
      {
        label: this.$t("_.imports"),
        route: {
          to: {
            name: "adminImports"
          }
        }
      },
      {
        label: this.$t("_.import")
      }
    ];
  }

  public getHostName(imports) {
    return imports?.credential?.hostname || imports?.name || "";
  }
}
